(function () {
    "use strict";

    // @ngInject
    function HomeControllerCtor($scope, $injector, $stateParams, HomeManager, TasksManager, WorkspacesManager, ReportsManager, UsersManager, _, AppStates, NavigationService, WorkspaceFileService, $translate,
                                $filter, moment, HomeService, $q, ModalService, AnalyticsService, ReferralService, SetupGuideService, UiPersistenceService, Enums, DeviceService, AccountsService, $state,
                                OnboardingService, UserService, SelfOnboardingManager, EventsManager, $window) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'HomeController';

        this.AppStates = AppStates;
        this.HomeManager = HomeManager;
        this.TasksManager = TasksManager;
        this.WorkspacesManager = WorkspacesManager;
        this.ReportsManager = ReportsManager;
        this._ = _;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.moment = moment;
        this.HomeService = HomeService;
        this.$q = $q;
        this.$window = $window;
        this.AnalyticsService = AnalyticsService;
        this.ReferralService = ReferralService;
        this.$scope = $scope;
        this.ModalService = ModalService;
        this.UiPersistenceService = UiPersistenceService;
        this.Enums = Enums;
        this.SetupGuideService = SetupGuideService;
        this.DeviceService = DeviceService;
        this.NavigationService = NavigationService;
        this.OnboardingService = OnboardingService;
        this.WorkspaceFileService = WorkspaceFileService;
        this.UsersManager = UsersManager;
        this.$translate = $translate;
        this.UserService = UserService;
        this.SelfOnboardingManager = SelfOnboardingManager;
        this.EventsManager = EventsManager;

        this.isMobileDevice = DeviceService.nxSmallBreakpoint();

        this.user = UsersManager.getCurrUser();
        this.activeUser =  this.user.companyHasSubscription();
        this.INQUIRIES_TO_SHOW = 2;
        this.MAX_CF_AWARENESS_SHOWS = 3;

        this.shouldShowCoronaBanner = 
            this.UiPersistenceService.getUiPersistence(
                this.UiPersistenceService.keys.showHomeCoronaBanner,
                { show: true }
            ).show

        this.isHomeForTrialer = this.HomeService.shouldShowHomeForTrialers();

        this._load();
        this.AnalyticsService.trackPageView(this, this.AnalyticsService.analytics_events.home_page);

        this.register(AccountsService, Enums.PubSubTriggers.companyChanged, () => {
            this._load();
        });

        this.testimonial = this.getTestimonial();
        this.footerLinks = this.getHomeForTrialFooterLinks();

        this.leadsSourceTooltip = {
            title : this.$translate.instant('HOME.TOOLTIPS.REPORTS.LEADS._TITLE_'),
            text: this.$translate.instant('HOME.TOOLTIPS.REPORTS.LEADS._TEXT_'),
            ctaText: this.$translate.instant('HOME.TOOLTIPS.REPORTS.LEADS._CTA_TEXT_'),
            ctaHandler: () => {
                this.goToState(this.AppStates.root_core_navigation_reports_analytics, {section: 'lead_source'});
            }
        };

        this.cfAwarenessProTip = {
            isVisible: this._setVisibleContactFormAwareness(),
            onClick: () => {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.home_contact_form_awareness);
                this._hideCfAwareness();
                this.goToState(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'});
            },
            boldText: this.$translate.instant('CONTACT_FORM.HOME_AWARENESS._PRO_TIP_'),
            text: this.$translate.instant('CONTACT_FORM.HOME_AWARENESS._TEXT_'),
            linkText: this.$translate.instant('CONTACT_FORM.HOME_AWARENESS._LINK_TEXT'),
        };

        if(this.user.isCompanyOwner()) {
            this._loadOnboardingContent();
        }

        this.shouldShowInteractive = this.onboardingContent === 'interactive' && !this.user.is_activated;
        WorkspacesManager.getWorkspacesCounts(this.user._id).then(function success(resp) {
            this.workspaceCount = resp.data.counts.all;
        }.bind(this));
        this.shouldShowSetupGuide = this.onboardingContent === 'streamlined_home' && (this.SetupGuideService.isSetupGuideActive() || this.SetupGuideService.isAccountSetupShown());

        const yearLastSawBirthdayModal = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.yearLastSawBirthdayModal, {year: ''}).year;
        const todayIsBirthday = this.UserService.isTodayUsersBirthday(this.user);
        const userHasIndividualBankAccountType = this.UserService.isBankAccountTypeIndividual(this.user);
        const thisYear = moment().format('YYYY');
        const haveNotSeenBirthdayModalThisYear = yearLastSawBirthdayModal !== thisYear;

        if (
            todayIsBirthday
            && userHasIndividualBankAccountType
            && haveNotSeenBirthdayModalThisYear
            && !this.isMobileDevice
        ) {
            this.ModalService.openBirthdayModal();
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.yearLastSawBirthdayModal, {year: thisYear});
            this.AnalyticsService.trackLoad(this, this.AnalyticsService.analytics_events.birthday_modal);
        }

        UserService.showGmailRevokedPopup(this.user);

      this.projectList = [];
        this.EventsManager.listCoronaRiskedProjects(true)
            .then(projects => {
              this.projectList = projects;
            });
    }


    Controllers.HomeController = Class(Controllers.BaseController, {
        constructor: HomeControllerCtor,

        _hideCfAwareness() {
            this.UiPersistenceService.setUiPersistenceInnerKey(
                this.UiPersistenceService.keys.contactFormDynamicOnboarding,
                'homeVisitCount',
                this.MAX_CF_AWARENESS_SHOWS
            );
        },

        _setVisibleContactFormAwareness() {

            let cfOnboardingPersistanceHash = this.UiPersistenceService.getUiPersistence(
                this.UiPersistenceService.keys.contactFormDynamicOnboarding,
                {homeVisitCount: 0}
            );

            let countVisited = cfOnboardingPersistanceHash.homeVisitCount || 0;

            let isFeatureVisible = countVisited < this.MAX_CF_AWARENESS_SHOWS && this.user.isShowContactFormAwareness();

            if (isFeatureVisible) {
                this.UiPersistenceService.setUiPersistenceInnerKey(
                    this.UiPersistenceService.keys.contactFormDynamicOnboarding,
                    'homeVisitCount',
                    countVisited + 1
                );
            }

            return isFeatureVisible;
        },

        _load() {
            this.HomeService.validateUserShouldSeeHome();
            this.handleMWebBlock();

            var mayExtendTrial = this.user.hasTrialExpired() && !this._.isEmpty(this.UsersManager.fillExtendTrialData({}));

            const bookeepingPromise = this.fetchBookkeeping();
            const tasksPromise = this.fetchTasks();
            const calendarPromise = this.fetchCalendar();
            const inquiriesAndActivityPromise = this.fetchInquiriesAndRecentActivity();
            const reportPromise = this.fetchReport();

            this.$q.all([bookeepingPromise, tasksPromise, calendarPromise, inquiriesAndActivityPromise, reportPromise]).finally(() => {
                this.$window.performance && this.$window.performance.mark('hb_home_shown');
            });
        },

        _loadOnboardingContent() {
            this.onboardingContent = this.OnboardingService.getOnboardingFlow();

            this.onboardingCardPersistence    = this.SetupGuideService.getPersistenceHomeOnboardingCard();
            this.hasClickedCompleteMwebWizard = this.onboardingCardPersistence.hasClickedCompleteMwebWizard;

            if (this.$stateParams.openOnboardingCard) {
                this.isOnboardingCardCollapsed = false;
            } else {
                this.isOnboardingCardCollapsed = this.onboardingCardPersistence.isCollapsed;
            }

            this.SetupGuideService.setPersistenceHomeOnboardingCard({ isCollapsed: this.isOnboardingCardCollapsed });

            this.onboardingResources = this.SetupGuideService.getInteractiveResources();
        },

        handleMWebBlock: function handleMWebBlock() {
            // Yona really wants to send the go to desktop email to everyone, so keeping this code until we get this 'approved' :)
            // this.isMwebBlocked = this.user.getExistingAbTestVariation(this.Enums.ABTests.mwebBlock) === 'blocked';
            // if (this.isMobileDevice && (this.isMwebBlocked && !this.user.has_logged_in_via_desktop)){
            //     this.openMwebBlockModal();
            //     this.SelfOnboardingManager.mwebToDesktopEmail();
            // }

            // if (this.isMobileDevice && !this.user.has_logged_in_via_desktop){
            //     this.SelfOnboardingManager.mwebToDesktopEmail();
            // }
        },

        setBackToState: function setBackToState(itemType) {
            this.NavigationService.setBackToState({ name: this.$state.current.name, params: this.$state.params });
        },

        openMwebBlockModal: function openMwebBlockModal() {
            this.ModalService.openMwebBlockModal();
        },

        clickHandlerSetupGuide: function (step) {

            // mark step as done
            if(!step.isComplete) {
                this.SetupGuideService.completeStep(step);
            }

            // run the click function
            if (step.clickHandler && angular.isFunction(step.clickHandler)) {
                step.clickHandler();
            }

            // track analytics
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.setup_guide_modal_task, {
                type: step.listKey === 'exploreItems' ? 'explore' : 'customize',
                setup_task: step.key,
                is_completed: step.isComplete,
                source: 'home_for_trialers',
                cta_location: 'list',
            });
        },

        getTestimonial : function getTestimonial() {
            const testimonials = [
                {
                    author: 'Jesse Debusk',
                    avatarPublicId : 'marketing_site/member-love/photos/hero/jesse_debusk',
                    body: 'HoneyBook has made the most tedious part of my job easy! It\'s given me more time to focus on doing what I love.'
                },
                {
                    author: 'Mark & Nicole Pasternack',
                    avatarPublicId : 'marketing_site/member-love/photos/hero/mark_nicole_pasternack',
                    body: 'HoneyBook has been a LIFE changer. HoneyBook has saved countless hours... and helped me book more clients.',
                },
                {
                    author: 'Samantha Heberlein',
                    avatarPublicId : 'marketing_site/member-love/photos/hero/Samantha_Heberlein',
                    body: 'HoneyBook has made booking and scheduling clients so much easier. It\'s like adding another employee to our business!',
                },
                {
                    author: 'Jacob Connell Photography',
                    avatarPublicId : 'marketing_site/member-love/photos/hero/jacob_connell',
                    body: 'All entrepreneurs should be using this platform to streamline their client communications, organize projects and manage invoicing.',
                },
            ];

            const randomIndex = this._.random(0, testimonials.length - 1);
            return testimonials[randomIndex];
        },

        getHomeForTrialFooterLinks : function getHomeForTrialFooterLinks() {
            return [
                {url: 'https://www.honeybook.com/product-education', title: 'Webinars'},
                {url: 'https://help.honeybook.com/', title: 'Help Center'},
                {url: 'https://www.honeybook.com/risingtide/', title: 'Blog'},
            ];
        },

        fetchBookkeeping: function fetchBookkeeping() {
            this.fetchingBookkeeping = true;
            return this.HomeManager.getHomebookkeeping().then(function success(resp) {
                    this.overduePayments = resp.data.overdue_payments;
                    this.recentPayments = resp.data.recent_payments;
                    this.emptyStateBookkeeping = this.overduePayments === 0 && this.recentPayments === 0;
            }.bind(this)).finally(function final() {
                this.fetchingBookkeeping = false;
            }.bind(this));
        },

        fetchTasks: function fetchTasks() {
            this.fetchingTasks = true;
            return this.TasksManager.fetchUserTasksCount().then(function success(resp) {
                this.allTasks = resp.data.all;
                this.todayTasks = resp.data.today;
                this.emptyStateTasks = this.allTasks === 0 && this.todayTasks === 0;
            }.bind(this)).finally(function final() {
                this.fetchingTasks = false;
            }.bind(this));
        },

        fetchCalendar: function fetchCalendar() {
            this.fetchingCalendar = true;
            return this.HomeManager.getCalendar().then(function success(resp) {
                this.eventsToday = resp.data.today;
                this.eventsThisWeek = resp.data.this_week;
                this.emptyStateCalendar = this.eventsToday === 0 && this.eventsThisWeek === 0;
            }.bind(this)).finally(function final() {
                this.fetchingCalendar = false;
            }.bind(this));
        },

        fetchInquiriesAndRecentActivity: function fetchInquiriesAndRecentActivity() {
            this.fetchingInquiriesAndRecentActivity = true;
            var inquiriesPromise = this.WorkspacesManager.getPipelineWorkspacesCounts(this.user._id).then(function success(resp) {
                var stages = resp.data.user_pipeline_stages;
                var inquiryStage = this._.find(stages, function(stage) {
                   return stage.type_cd === 0;
                });

                this.inquiryStageId = inquiryStage._id;

                this.pendingInquiriesCount = inquiryStage.counts.active;
                var params = {
                    page: 1,
                    perPage: this.INQUIRIES_TO_SHOW,
                    leanFormat: true,
                    sortBy: 'created_at',
                    sortDesc: true,
                    stageId: this.inquiryStageId
                };

                var promise = this.$q.when({data: {data: []}});

                if (this.pendingInquiriesCount) {
                    promise = this.WorkspacesManager.getPipelineWorkspacesPromise(params);
                }

                return promise;
            }.bind(this)).then(function success(resp) {
                this.pendingInquiries = resp.data.data;
            }.bind(this));

            var recentActivityPromise = this.HomeManager.getRecentActivity().then(function(resp) {
                this.recentActivitiesCount = resp.data.recent_activities_count;
                this.recentActivities = resp.data.recent_activities;
            }.bind(this));

            return this.$q.all([inquiriesPromise, recentActivityPromise]).finally(function final() {
                this.fetchingInquiriesAndRecentActivity = false;
            }.bind(this));
        },


        isShowReportsEmptyState: function isShowReportsEmptyState() {
            return this.activeUser && !this.topLeadSourceLabel && !this.valueOfBookingForYear;
        },


        fetchReport: function fetchReport() {
            this.fetchingReport = true;
            var leadSourcePromise = this.ReportsManager.getLeadsReportTotals().then(function success(resp) {

                this.leadSourceNewBadgeSeenCount = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadsReportNewBadge, {count: 0}).count;
                if (this.leadSourceNewBadgeSeenCount < 3) {
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadsReportNewBadge, {count: this.leadSourceNewBadgeSeenCount + 1});
                }


                var topLeadSource = this._.find(resp.data.leads, function (leadSource) {
                    return leadSource.label !== undefined && leadSource.label !== 'Unknown';
                });
                if (topLeadSource) {
                    this.topLeadSourceLabel = topLeadSource.label;
                }
            }.bind(this));

            var reportAnalyticsPromise = this.ReportsManager.getReportsAnalytics().then(function success(resp) {
                this.bookingAmount = resp.data[this.moment().year()].files_booked_payments_value_sum;
                if (this.bookingAmount) {
                    this.valueOfBookingForYear = this.$filter('hbthousandSuffix')(this.bookingAmount);
                }
            }.bind(this));

            return this.$q.all([leadSourcePromise, reportAnalyticsPromise]).finally(function final() {
                this.fetchingReport = false;
            }.bind(this));
        },

        goTo: function goTo(view, analyticsEvent) {
            // track
            this.trackAnalytics(analyticsEvent);

            // route
            this.goToState(view, {});
        },

        trackAnalytics: function(analyticsEvent){
            this.AnalyticsService.trackClick(this.$scope, analyticsEvent, {
                variant: this.isHomeForTrialer ? 'home_for_trialers' : 'home_for_subscribers'
            });
        },

        analyticsProperties: function analyticsProperties() {
            return { source: 'home' };
        },

        goToReferrals: function goToReferrals() {
            this.AnalyticsService.track(this.$scope, this.AnalyticsService.analytics_events.my_benefits_button_click, {
                campaign_uid: this.ReferralService.userCampaignUid
            });
        },

        clickOnRecentActivities: function clickOnRecentActivities(recentActivity) {

            if (recentActivity.type === this.Enums.homeRecentActivityTypes.feed_message) {
                this.NavigationService.setBackToState({ name: this.$state.current.name, params: this.$state.params });
                this.goToState(this.AppStates.root_core_navigation_event_workspace_feed, {event_id: recentActivity.project_id, workspace_id: recentActivity.workspace_id});
                this.AnalyticsService.track(this.$scope, this.AnalyticsService.analytics_events.go_to_workspace);
            } else if (recentActivity.type === this.Enums.homeRecentActivityTypes.contract_signed) {
                this.goToState(this.AppStates.root_core_workspaceFile, {workspace_file_id: recentActivity.workspace_file_id});
                this.AnalyticsService.track(this.$scope, this.AnalyticsService.analytics_events.go_to_contract);
            }
        },

        openMobileAppIntro: function openMobileAppIntro() {
            if (!this.isMobileDevice) {
                this.ModalService.openMobileAppIntroModal().finally(function (result) {
                    this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.mobileAppIntro, {dontShow: true});
                }.bind(this));
            }
        },

        isFadeActive: function isFadeActive() {
            var userIsNotActivated = !this.user.is_activated;
            var setupGuideIsActive =
                (this.onboardingContent === 'streamlined_home' && this.SetupGuideService.isSetupGuideActive())
                || (this.onboardingContent === 'interactive' && (!this.OnboardingService.allOnboardingStepsAreComplete() || !this.onboardingCardPersistence.hasMarkedComplete));
            return (
                setupGuideIsActive
                && userIsNotActivated
                && !this.isOnboardingCardCollapsed
            );
        },

      goToCoronaPage: function goToCoronaPage() {
            this.goToState(this.AppStates.root_core_navigation_corona);
      },

      dismissCoronaBanner() {
            this.shouldShowCoronaBanner = false;
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showHomeCoronaBanner, { show: false })
      },

    });
}());
